<template>
<!-- eslint-disable -->
  <v-app>
    <v-main>
      <v-container class="fill-height" fluid>
        <v-row align="center" justify="center">
          <v-col cols="12" sm="8" md="6" lg="4">
            <v-card class="elevation-12" style="background-color: #363636">
              <div class="px-3 pt-3">
                <v-img contain :src="require('@/assets/logo2.png')" transition="scale-transition" />
              </div>
              <v-card-text>
                <v-row justify="center" align="center">
                  <v-progress-circular
                    size="100"
                    indeterminate
                    color="viralYellow"
                  />
                </v-row>
              </v-card-text>
            </v-card>
          </v-col>
        </v-row>
      </v-container>
    </v-main>
  </v-app>
</template>

<script>
import { mapActions } from 'vuex'
export default {
  data() {
    return {
      waiting: false
    }
  },
  async created() {
    const params = this.$route.query
    try {
      if (params.access === 'vip') {
        localStorage.setItem('access', 'vip')
      } else {
        localStorage.setItem('access', 'normal')
      }
      await this.enrichment()
    } catch (e) {
      this.$router.push({ name: 'login', query: { access: 'enrichmentFailed' } })
    }
  },
  methods: {
    ...mapActions({
      enrichment: 'login/enrichment',
      addAlert: 'alerts/add'
    })
  }
}
</script>
